import {
  HttpClient,
  HttpErrorResponse,
  HttpEventType,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VendorSearchQuery } from 'src/app/shared/models/app-models/VendorSearchQuery.model';
import {
  MaterialGroup,
  MaterialSubGroup,
  OrderNumber,
  StandardMaterial,
  OEM,
  Brand,
  CostCentre,
  GLAccount,
  Currency,
  AttachmentInfo,
  Country,
  ApprovingOfficerSummary,
  MaterialGroupCondition,
  VendorACLASL,
  CurrentWorkFlowHistory,
  WorkflowRecord,
  WorkflowHistory,
  WorkflowOfficer,
  ApprovingPersonnel,
  FundCentre,
  SaveMyPurchase,
  VendorDetails,
  Attachment,
  BodySendRFQs,
  BodyPrint,
  BodyGetRFQDocument,
  PrintDocument,
  OutputHistories,
  DeliveryAddressI,
  VendorDetail,
  ContractExecutive,
  WorkflowHeader,
  Actioner,
  SystemConfiguration,
  Vendor,
  AdditionalNotes,
  ReminderPrompter,
  ValidationExceptionsValid,
  ReasonForNotUsingRFQ,
} from 'src/app/shared/models/database-models';
import { AuthService } from 'src/app/auth/service/auth.service';
import { MyWorkListData } from 'src/app/shared/models/database-models/MyWorklist.model';
import { MyDocumentsData } from 'src/app/shared/models/database-models/MyDocuments.model';
import { VendorSearchList } from 'src/app/modules/mypurchase-form/item-vendor/add-vendor/vendor-search-dialog/vendor-search-dialog.component';
import { AttachmentData } from 'src/app/modules/mypurchase-form/attachments/attachment.component';
import { ExtendedWOCReason } from 'src/app/shared/models/app-models/ExtendedWOCReason.model';
import { ExtendedDOTPReason } from 'src/app/shared/models/app-models/ExtendedDOTPReason.model';
import { PermissibleReason } from 'src/app/shared/models/app-models/PermissibleReason.model';
import { AuditLogHeader } from '../../shared/models/database-models/AuditLog';
import { AuditLogHeaderData, AuditLogHistoryData } from '../../modules/shared/audit-log/audit-log.component';
import { RfsSourcingResponse } from 'src/app/shared/components/global-banner/dto/rfs-sourcing-response.model';
import { TransferRfsDto } from 'src/app/modules/approving-officer-page/purchasing-executive-assignment-list/dto/transfer-rfs.model';
import { ProjectVoteInfo } from 'src/app/shared/models/app-models/ProjectVoteInfo.model';
import { ReferenceRecord, RFQReferenceRecord } from 'src/app/modules/mypurchase-form/reference/dto/reference-record.model';
import { AclAslReqDto, AclAslVendor } from 'src/app/modules/mypurchase-form/item-vendor/add-vendor/asl-vendor-search-dialog/dto/find-acl-asl-req.dto';
import { CurrencyExchange } from 'src/app/shared/models/database-models/CurrencyExchange.model';
import { GeneratedWorkFlowHistory } from 'src/app/shared/models/database-models/WorkflowHistory.model';
import { OtherBudgetRequest } from "src/app/shared/models/sap-models/otherBudgetRequest";
import { OthersBudget } from "src/app/shared/models/sap-models/otherBudget";
import { WBSBudgetRequest } from "src/app/shared/models/sap-models/WBSBudgetRequest";
import { WBSBudget } from "src/app/shared/models/sap-models/wbsBudget";
import { ProjectCodesRequirePDPCompliance } from 'src/app/shared/models/database-models/PDPGovernanceFactor.model';
import { DocumentReference } from 'src/app/shared/models/database-models/DocumentReference.model';
import { Router } from '@angular/router';
import { RecommendingOfficersSelection } from 'src/app/shared/models/app-models/RecommendingOfficerReselection.model';
import { officerReselectionDto } from 'src/app/modules/mypurchase-form/dro-dialog/officer-reselection-dto.model';
import { returnFormItemWithoutSoftDeletedModels } from 'src/app/modules/shared/utils/remove-soft-deleted-models';
import { PurchaseExecutiveListResponse, PurchaseExecutivesReportRequest, PurchaseExecutivesReportResponse, RFQDetailsFilter, RFQReportRequest, RFQSummaryReportResponse } from 'src/app/shared/models/database-models/PurchaseExecutivesReport.model';
import { DocumentLock } from 'src/app/shared/models/database-models/DocumentLock';
import { CheckRFSReadyRequest, CheckRFSReadyResponse, ReadyTaggingRequest, UnreadyTaggingRequest } from 'src/app/shared/models/database-models/RFS.model';
import { RfqItem } from 'src/app/modules/mypurchase-form/rfq-output/rfq-output.service';
import { PurchaseExecutives } from 'src/app/shared/models/database-models/PurchaseExecutives.model';
import { MarkasDone, MyPEWorkListData } from 'src/app/shared/models/database-models/MyWorklist.model';
import { EstimatedUsages } from 'src/app/shared/models/database-models/EstimatedUsages.model';
import { SourcingOutcomeInformation, SourcedItem } from 'src/app/shared/models/app-models/SourcingOutcome.model';
import { rfqListDropDown } from 'src/app/shared/models/app-models/DropDown.model';
import { DropDownOptions } from 'src/app/shared/models/app-models';
import { ReasonForNoQuotaionItem, SummaryDropdown } from 'src/app/modules/rfq-summary/rfq-summary.component';
import { PurchaseGroup } from 'src/app/shared/models/app-models/PurchaseGroup.model';
import { MPMMSInformation } from 'src/app/shared/models/app-models/MPMMSInformation.model';
@Injectable({
  providedIn: 'root',
})
export class BackendApiService {
  apiURL: string = environment.mpAPI.url;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  // retrieve MG (Parent)
  retrieveMG() {
    let API_URL = `${this.apiURL}/api/getMaterialGroup`;
    return this.http
      .get<MaterialGroup[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }
  // retrieve MG (Sub Group)
  retrievePermissibleReasons() {
    let API_URL = `${this.apiURL}/api/getPermissibleReasons`;
    return this.http
      .get<PermissibleReason[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }
  // retrieve MG (Sub Group)
  retrieveSubMG() {
    let API_URL = `${this.apiURL}/api/getMaterialSubGroup`;
    return this.http
      .get<MaterialSubGroup[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }
  // search vendors
  getAssignmentList(documentNumber: string, username: string) {
    //api/getAssignmentList/MPN923000372
    let API_URL = `${this.apiURL}/api/getAssignmentList/${documentNumber}/${username}`;
    console.log(API_URL)
    //let API_URL = `${this.apiURL}/api/getAssignmentList/MPN923000394/nyangpin`;
    return this.http
      .get<any>(`${API_URL}`)
      .pipe(catchError(this.error));
  }
  transferRFS(payload: TransferRfsDto) {
    let API_URL = `${this.apiURL}/api/transferRFS`;
    return this.http
      .post<any>(`${API_URL}`, payload)
      .pipe(catchError(this.error));
  }

  takeoverRFS(payload: TransferRfsDto) {
    let API_URL = `${this.apiURL}/api/takeoverRFS`;
    return this.http
      .post<any>(`${API_URL}`, payload)
      .pipe(catchError(this.error));
  }

  // retreive order number
  retreiveOrderNumberByCostCentre(costCentre: string) {
    let API_URL = `${this.apiURL}/api/getOrderNumberByCostCentre/`;
    return this.http
      .get<OrderNumber[]>(`${API_URL}` + costCentre)
      .pipe(catchError(this.error));
  }

  // sml check
  getSML(partNumber: string) {
    let API_URL = `${this.apiURL}/api/getStandardMaterial/`;
    return this.http.get<StandardMaterial>(`${API_URL}` + partNumber);
  }

  // retrieve OEM list
  // @deprecated: this method should not be used, please use getBrands()
  getOEM() {
    let API_URL = `${this.apiURL}/api/getOEM/`;
    return this.http.get<OEM[]>(`${API_URL}`);
  }

  getBrands(materialCode?: string) {
    let API_URL = `${this.apiURL}/api/getBrands${materialCode ? `/` + materialCode : ''}`;
    return this.http.get<Brand[]>(`${API_URL}`);
  }

  // retreive cost centre
  getCostCentre() {
    let API_URL = `${this.apiURL}/api/getCostCentre`;
    return this.http
      .get<CostCentre[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  // retrieve GL/Accounts
  getGLAccount() {
    let API_URL = `${this.apiURL}/api/getGLAccount`;
    return this.http
      .get<GLAccount[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  //retrieve a list of currency
  getCurrecies() {
    let API_URL = `${this.apiURL}/api/getCurrency`;
    return this.http.get<Currency[]>(`${API_URL}`).pipe(catchError(this.error));
  }

  //retrieve attachment purpose type and extension
  getAttachmentInfo() {
    let API_URL = `${this.apiURL}/api/getAttachmentInfo`;
    return this.http
      .get<AttachmentInfo>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getProjectCode(roName?: string) {
    let API_URL = ''
    if (roName) API_URL = `${this.apiURL}/api/getProjectCode/${roName}`;
    else API_URL = `${this.apiURL}/api/getProjectCode`
    return this.http.get<any>(`${API_URL}`).pipe(catchError(this.error));
  }

  getProjectBudget() {
    let API_URL = `${this.apiURL}/api/getWBS`;
    return this.http.get(`${API_URL}`).pipe(catchError(this.error));
  }

  getProjectCodesRequirePDPCompliance(projectCodes: string[]) {
    let API_URL = `${this.apiURL}/api/getProjectCodesRequirePDPCompliance`;
    return this.http.post<ProjectCodesRequirePDPCompliance>(`${API_URL}`, { projectCodes }).pipe(catchError(this.error));
  }

  // search vendors
  searchVendors(queries: VendorSearchQuery, page: string, limit: string) {
    let API_URL = `${this.apiURL}/api/searchVendors`;
    return this.http
      .post<VendorSearchList>(`${API_URL}/${limit}/${page}`, queries)
      .pipe(catchError(this.error));
  }

  // save MyPurchase
  saveMyPurchase(object: SaveMyPurchase) {
    let payload = returnFormItemWithoutSoftDeletedModels(object)
    let API_URL = `${this.apiURL}/api/saveMyPurchaseRequest`;
    return this.http.post(`${API_URL}`, payload).pipe(catchError(this.detailedError));
  }

  // generate RFQ
  generateRFQ(object: any) {
    let API_URL = `${this.apiURL}/api/generateRFQs`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }

  getMyDocuments(
    pageNumber: string = '1',
    filter: string = 'Draft',
    limit: string,
    column: string | null = null,
    isAsc: string | null = null,
    isDeletedVisibility: boolean | false = false,
  ) {
    let API_URL = `${this.apiURL}/api/getMyDocuments`;
    if (column) {
      return this.http
        .get<MyDocumentsData>(
          `${API_URL}/${filter}/${limit}/${pageNumber}?column=${column}&isAsc=${isAsc}/${isDeletedVisibility}`
        )
        .pipe(catchError(this.error));
    } else {
      return this.http
        .get<MyDocumentsData>(
          `${API_URL}/${filter}/${limit}/${pageNumber}/${isDeletedVisibility}`
        )
        .pipe(catchError(this.error));
    }
  }

  getReferenceTable(documentNumber: string) {
    let API_URL = `${this.apiURL}/api/getReferenceTable`;
    return this.http
      .get<ReferenceRecord[]>(
        `${API_URL}/${documentNumber}`
      )
      .pipe(catchError(this.error));
  }
  searchMyDocuments(requestingOfficer: string,
    filterByDocumentNumber: string,
    pageNumber: string = '1',
    limit: string,
    isDeletedVisibility: boolean = false
  ) {
    let API_URL = `${this.apiURL}/api/searchMPDocuments`;
    // Pass isDeletedVisibility as a query param
    return this.http
      .get<MyDocumentsData>(
        `${API_URL}/${limit}/${pageNumber}/${requestingOfficer}/${filterByDocumentNumber}?isDeletedVisibility=${isDeletedVisibility}`)
      .pipe(catchError(this.error));
  }


  // retrieve list of countries
  getCountries() {
    let API_URL = `${this.apiURL}/api/getCountries`;
    return this.http.get<Country[]>(`${API_URL}`).pipe(catchError(this.error));
  }
  // retrieve documentsAO
  getDocumentsForAO(
    user: string,
    filter: string,
    limit: string,
    pageNumber: string,
    column: string | null = null,
    isAsc: string | null = null,
  ) {
    let token = '';
    // await this.auth.getUserSessionId().then((data) => token = data)
    console.log(token);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const httpOptions = {
      headers: httpHeaders,
    };
    let API_URL = `${this.apiURL}/api/getAODocuments/`;
    if (column) {
      return this.http
        .get<MyWorkListData>(
          `${API_URL}` + user + `/${filter}/${limit}/${pageNumber}?column=${column}&isAsc=${isAsc}`,
          httpOptions
        )
        .pipe(catchError(this.error));
    }
    else {
      return this.http
        .get<MyWorkListData>(
          `${API_URL}` + user + `/${filter}/${limit}/${pageNumber}`, httpOptions
        )
        .pipe(catchError(this.error));
    }
  }

  // retrieve draft data
  getDraft(documentNumber: string) {
    let API_URL = `${this.apiURL}/api/getDraft`;
    return this.http
      .get<SaveMyPurchase>(`${API_URL}/${documentNumber}`)
      .pipe(catchError(this.redirectIfUnauthorized.bind(this)), catchError(this.error));
  }

  deleteDraft(documentNumber: string) {
    let API_URL = `${this.apiURL}/api/deleteDraft`;
    return this.http
      .post<any>(`${API_URL}`,{documentNumber: documentNumber})
      .pipe(catchError(this.redirectIfUnauthorized.bind(this)), catchError(this.error));
  }

  // Submit MyPurchase data
  submitMyPurchase(object: SaveMyPurchase) {
    let payload = returnFormItemWithoutSoftDeletedModels(object)
    let API_URL = `${this.apiURL}/api/submitMyPurchaseRequest`;
    return this.http.post<any>(`${API_URL}`, payload).pipe(catchError(this.detailedError));
  }

  // Submit SOW MyPurchase data
  triggerSOW(DocumentNo: string) {
    let API_URL = `${this.apiURL}/api/triggerSOW/${DocumentNo}`;
    return this.http.get(`${API_URL}`).pipe(catchError(this.error));
  }

  //retrieve AO MP Document Summary
  getAOSummary(MPDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/MPDetailsForAO/`;
    return this.http
      .get<ApprovingOfficerSummary>(`${API_URL}` + MPDocumentNumber)
      .pipe(catchError(this.error));
  }

  // retrieve workflow header for ao
  getAOWorkFlow(MPDocumentNumber: string, dagId: string) {
    let API_URL = `${this.apiURL}/api/MPDetailsForAO/`;
    return this.http
      .get<WorkflowHeader>(`${API_URL}` + MPDocumentNumber + `/${dagId}`)
      .pipe(catchError(this.error));
  }

  //getVendorNameById
  getVendorNameById(vendorId: string) {
    let API_URL = `${this.apiURL}/api/getVendorByNumber/`;
    return this.http
      .get<{ Name: string }[]>(`${API_URL}` + vendorId)
      .pipe(catchError(this.error));
  }

  //submit AO to airflow
  recommendBudget(object: any) {
    let API_URL = `${this.apiURL}/api/recommendBudget`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.detailedError));
  }

  getProjectVoteInfo(projectCode: string) {
    let API_URL = `${this.apiURL}/api/getProjectVoteInfo/${projectCode}`;
    return this.http.get<ProjectVoteInfo>(`${API_URL}`).pipe(catchError(this.error));
  }
  //submit AO to airflow
  approveBudget(object: any) {
    let API_URL = `${this.apiURL}/api/approveBudget`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.detailedError));
  }

  //submit AO to airflow
  endorseBudget(object: any) {
    let API_URL = `${this.apiURL}/api/endorseBudget`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.detailedError));
  }

  //submit AO to airflow
  releaseBudget(object: any) {
    let API_URL = `${this.apiURL}/api/releaseBudget`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.detailedError));
  }


  //retreive mg name ny code
  getMGNameByCode(materialCode: string) {
    let API_URL = `${this.apiURL}/api/getMaterialGroupByCode/`;
    return this.http
      .get<{ Name: string }[]>(`${API_URL}` + materialCode)
      .pipe(catchError(this.error));
  }

  //get current workflowHistory
  getCurrentWorkflowHistory(MPdocNumber: string) {
    let API_URL = `${this.apiURL}/api/getCurrentWorkflowHistory/${MPdocNumber}`;
    const headerOptions = {
      headers: this.headers,
    };
    return this.http
      .get<CurrentWorkFlowHistory>(API_URL, headerOptions)
      .pipe(catchError(this.error));
  }

  generateWorkflowForDraftDocument(MPdocNumber: string, actioner: string) {
    let API_URL = `${this.apiURL}/api/generateWorkflow/${MPdocNumber}/${actioner}`;
    const headerOptions = {
      headers: this.headers,
    };
    return this.http
      .get<CurrentWorkFlowHistory>(API_URL, headerOptions)
      .pipe(catchError(this.error));
  }


  getCurrencyExchange(currency: string) {
    let API_URL = `${this.apiURL}/api/getCurrencyExchange/${currency}`;
    const result = this.http.get<CurrencyExchange>(API_URL).pipe(catchError(this.error));
    return result
  }

  //get Complete workflowHistory
  getCompleteWorkflowHistory(MPdocNumber: string, limit: number, pageNumber: number) {
    let API_URL = `${this.apiURL}/api/getCompleteWorkflowHistory/`;
    const headerOptions = {
      headers: this.headers,
    };
    return this.http
      .get<WorkflowHistory>(`${API_URL}${MPdocNumber}/${limit}/${pageNumber}`, headerOptions)
      .pipe(catchError(this.error));
  }
  // Submit Recall
  recallDocument(object: any) {
    let API_URL = `${this.apiURL}/api/recallDocument`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  // Submit Terminate Document
  terminateTenderDocument(object: any) {
    let API_URL = `${this.apiURL}/api/tenderTerminate`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  //handle Errors
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

  errorForRORecall(error: HttpErrorResponse) {
    return throwError(() => {
      return error;
    });
  }

  detailedError(error: HttpErrorResponse) {
    return throwError(() => {
      return error;
    });
  }

  redirectIfUnauthorized(error: HttpErrorResponse) {
    // Redirect to unauthorized page if error status code is 401 Unauthorized
    if (error?.status === 401) {
      this.router
        .navigateByUrl('/redirect')
        .then(() => {
          this.router.navigate(['/unauthorized']);
        });
    }

    return throwError(() => error);
  }

  completeOnlinePurchase(mpDocNo: string) {
    const url = `${this.apiURL}/api/completeOnlinePurchase/${mpDocNo}`;
    return this.http
      .get(url)
      .pipe(catchError(this.error));
  }
  // get workflow user list
  getWorkflowUserList(
    mpDocNumber: string,
    dragRunId: string,
    statusCode: string
  ) {
    const url = `${this.apiURL}/api/getForwardWorkFlowUserList/${mpDocNumber}/${dragRunId}/${statusCode}`;
    return this.http
      .get<{ Officer: WorkflowOfficer[] }>(url, { headers: this.headers })
      .pipe(catchError(this.error));
  }

  // forward document to user
  forwardToUser(body: any) {
    const url = `${this.apiURL}/api/ForwardWorkFlow`;

    return this.http
      .post(url, body, { headers: this.headers, responseType: 'text' })
      .pipe(catchError(this.error));
  }

  // get project budget Approving Personnels
  getProjectBudgetApprovingPersonnel(
    projectCode: string,
    projectBudget: string,
    projectAmount: string
  ) {
    let API_URL = `${this.apiURL}/api/getProjectAO/${projectCode}/${projectBudget}/${projectAmount}`;
    return this.http
      .get<{ AOList: ApprovingPersonnel[] }>(API_URL)
      .pipe(catchError(this.error));
  }

  // get func centres
  getFundCentres() {
    let API_URL = `${this.apiURL}/api/FundCentre`;
    return this.http.get<FundCentre[]>(API_URL).pipe(catchError(this.error));
  }

  // get vendors by MPnumber

  getVendorsByMPNumber(mpDocNumber: string) {
    let API_URL = `${this.apiURL}/api/MPVendorDetails`;
    return this.http
      .get<VendorDetails[]>(API_URL + `/${mpDocNumber}`)
      .pipe(catchError(this.error));
  }

  getACLASLVendors(aclAslReqDto: AclAslReqDto): Observable<AclAslVendor[]> {
    let API_URL = `${this.apiURL}/api/getACLASLVendors`;
    return this.http.post<AclAslVendor[]>(API_URL, aclAslReqDto).pipe(catchError(this.error));
  }

  getDocumentAttachments(mpDocNumber: string) {
    let token = '';
    // await this.auth.getUserSessionId().then((data) => token = data)
    console.log(token);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const httpOptions = {
      headers: httpHeaders,
    };
    let API_URL = `${this.apiURL}/api/getAttachment/${mpDocNumber}`;
    return this.http
      .get<AttachmentData>(`${API_URL}`, httpOptions)
      .pipe(catchError(this.error));
  }

  uploadAttachment(attachment: Attachment) {
    let token = '';
    // await this.auth.getUserSessionId().then((data) => token = data)
    console.log(token);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const httpOptions = {
      headers: httpHeaders,
    };
    let API_URL = `${this.apiURL}/api/uploadAttachment`;
    return this.http.post(API_URL, attachment).pipe(catchError(this.error));
  }

  downloadAttachment(attachmentId: string) {
    let token = '';
    // await this.auth.getUserSessionId().then((data) => token = data)
    console.log(token);
    const httpHeaders = new HttpHeaders({
      responseType: 'blob',
      Authorization: 'Bearer ' + token,
    });
    const httpOptions = {
      headers: httpHeaders,
    };
    let API_URL = `${this.apiURL}/api/downloadAttachment/${attachmentId}`;
    return this.http
      .get<any>(API_URL)
      .pipe(catchError(this.error));

  }

  sendRFQs(body: BodySendRFQs) {
    let API_URL = `${this.apiURL}/api/sendRFQs`;
    return this.http.post(`${API_URL}`, body).pipe(catchError(this.error));
  }
  getRFQDocument(body: BodyGetRFQDocument) {
    let API_URL = `${this.apiURL}/api/getRFQDocument`;
    return this.http
      .post<PrintDocument>(`${API_URL}`, body)
      .pipe(catchError(this.error));
  }
  getOutputHistory(MPDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/getOutputHistory`;
    return this.http
      .get<{ OutputHistory: OutputHistories[] }>(`${API_URL}/${MPDocumentNumber}`)
      .pipe(catchError(this.error));
  }
  getRFQs(body: BodyPrint) {
    let API_URL = `${this.apiURL}/api/getRFQs`;
    return this.http
      .post<PrintDocument>(`${API_URL}`, body)
      .pipe(catchError(this.error));
  }
  getDeliveryAddress() {
    let API_URL = `${this.apiURL}/api/getDeliveryAddress`;
    return this.http
      .get<DeliveryAddressI[]>(API_URL)
      .pipe(catchError(this.error));
  }
  getVendorDetail(VendorNumber: string) {
    let API_URL = `${this.apiURL}/api/vendors/${VendorNumber}`;
    return this.http.get<VendorDetail>(API_URL).pipe(catchError(this.error));
  }
  getContractExecutive() {
    let API_URL = `${this.apiURL}/api/getContractExecutives`;

    return this.http.get<ContractExecutive>(API_URL).pipe(catchError(this.error));
  }
  assignCE(object: any) {
    let API_URL = `${this.apiURL}/api/assignCE`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  saveTender(object: any) {
    let API_URL = `${this.apiURL}/api/tenderSave`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  saveTagging(object: any) {
    let API_URL = `${this.apiURL}/api/saveRFS`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  readyTagging(object: ReadyTaggingRequest) {
    let API_URL = `${this.apiURL}/api/readyRFS`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  unreadyTagging(object: UnreadyTaggingRequest) {
    let API_URL = `${this.apiURL}/api/unreadyRFS`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  checkRFSReady(object: CheckRFSReadyRequest) {
    let API_URL = `${this.apiURL}/api/checkReady`;
    return this.http.post<CheckRFSReadyResponse>(`${API_URL}`, object).pipe(catchError(this.errorForRORecall));
  }
  submitTender(object: any) {
    let API_URL = `${this.apiURL}/api/submitTenderDocuments`;
    return this.http.post(`${API_URL}`, object).pipe(catchError(this.error));
  }
  getObsoletePart(partNumber: string) {
    let API_URL = `${this.apiURL}/api/getPreferredPart/${partNumber}`;
    return this.http.get(API_URL).pipe(catchError(this.error));
  }
  getCTDManagers() {
    let API_URL = `${this.apiURL}/api/findCTDManagers`;
    return this.http.get<string[]>(API_URL).pipe(catchError(this.error));
  }

  RoutingtoCE(mpDocNumber: string, userName: string) {
    let API_URL = `${this.apiURL}/api/VerifyCECTDUser/${mpDocNumber}/${userName}`;
    return this.http
      .get<{ RoutingtoCE: any[] }>(API_URL)
      .pipe(catchError(this.error));
  }

  getCoveringOfficers(officers: Actioner) {
    let API_URL = `${this.apiURL}/api/getCoveringOfficers`;
    return this.http.post<Actioner>(API_URL, { officers: officers }).pipe(catchError(this.error));
  }
  getWocReasons() {
    let API_URL = `${this.apiURL}/api/getReasonForWoc`;
    return this.http.
      get<ExtendedWOCReason[]>(API_URL).pipe(catchError(this.error));
  }
  getWocFile(WOCCode: string) {
    let API_URL = `${this.apiURL}/api/getWocFileReferenceNumber/${WOCCode}`;
    return this.http.
      get<any[]>(API_URL).pipe(catchError(this.error));
  }
  getDotpReasons() {
    let API_URL = `${this.apiURL}/api/getReasonForDOTP`;
    return this.http.
      get<ExtendedDOTPReason[]>(API_URL).pipe(catchError(this.error));
  }
  getPreApproved(pageSize: number, pageIndex: number, searchTerm?: string) {
    let API_URL = `${this.apiURL}/api/getPreApproved/${pageSize}/${pageIndex}`;
    if (searchTerm) API_URL += `/${searchTerm}`
    const result = this.http.
      get<any>(API_URL).pipe(catchError(this.error));
    return result
  }

  getAuditLogHeader(MPdocNumber: string, startDate?: Date, endDate?: Date) {
    let API_URL = `${this.apiURL}/api/getAudit`;
    if (!startDate || !endDate) {
      startDate = new Date()
      startDate.setDate(startDate.getDate() - 6)
      endDate = new Date()
    }
    const body = {
      MPDocumentNumber: MPdocNumber,
      start: startDate,
      end: endDate,
    }
    const headerOptions = {
      headers: this.headers,
    };
    return this.http
      .post<AuditLogHeaderData>(`${API_URL}`, body, headerOptions)
      .pipe(catchError(this.error));
  }
  getDrosForReselection(mpDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/getReselectDROs/${mpDocumentNumber}`;
    const headerOptions = {
      headers: this.headers,
    };
    return this.http
      .get<RecommendingOfficersSelection[]>(`${API_URL}`, headerOptions)
      .pipe(catchError(this.error));
  }

  reselectDros(reselectDroPayload: officerReselectionDto) {
    let API_URL = `${this.apiURL}/api/reselectDRO`;
    const headerOptions = {
      headers: this.headers,
    };
    return this.http
      .post(`${API_URL}`, reselectDroPayload)
      .pipe(catchError(this.error));
  }
  getAuditLogHistory(auditHeaderId: string, limit: string, pageNumber: string) {
    let API_URL = `${this.apiURL}/api/auditHistory/${auditHeaderId}/${limit}/${pageNumber}`;
    const headerOptions = {
      headers: this.headers,
    };
    return this.http
      .get<AuditLogHistoryData>(`${API_URL}`, headerOptions)
      .pipe(catchError(this.error));
  }

  getSourcingOutcomes(docNo: string) {
    let API_URL = `${this.apiURL}/api/getSourcingResults/${docNo}`;
    const result = this.http.get<RfsSourcingResponse>(API_URL).pipe(catchError(this.error));
    return result
  }

  getSystemConfiguration(code: string) {
    let API_URL = `${this.apiURL}/api/GetSystemConfiguration/${code}`;
    const result = this.http.get<SystemConfiguration>(API_URL).pipe(catchError(this.error));
    return result
  }

  getSystemConfigurations(codes: string[]) {
    let API_URL = `${this.apiURL}/api/GetSystemConfigurations`;
    const result = this.http
      .post<SystemConfiguration[]>(API_URL, { codes })
      .pipe(catchError(this.error));
    return result;
  }

  getValidationExceptionsValid(MPDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/getValidationExceptionsValid/${MPDocumentNumber}`;
    const result = this.http
      .get<ValidationExceptionsValid>(API_URL)
      .pipe(catchError(this.error));
    return result;
  }

  getAdditionalNotes(codes: string[]) {
    let API_URL = `${this.apiURL}/api/getAdditionalNotes`;
    return this.http
      .post<AdditionalNotes[]>(`${API_URL}`, { codes: codes })
      .pipe(catchError(this.error));
  }

  getReminderPrompters(codes: string[]) {
    let API_URL = `${this.apiURL}/api/getReminderPrompters`;
    return this.http
      .post<ReminderPrompter[]>(`${API_URL}`, { codes: codes })
      .pipe(catchError(this.error));
  }

  checkBudgetOTH(fundCentre: string, costCentre: string, glAccount: string, orderNumber: string, deliveryDate: string, tableFP: string, tableCB: string) {
    const othObject: OtherBudgetRequest = {
      "Method": "CHECK_BUDG_OTH",
      "FUND_CENTER": fundCentre,
      "COST_CENTER": costCentre,
      "GL_ACCOUNT": glAccount,
      "ORDER_NUMBER": orderNumber,
      "DELIVERY_DATE": deliveryDate,
      "TABLE_CB": tableCB,
      "TABLE_FP": tableFP
    }
    let API_URL = `${this.apiURL}/sapapi/checkBudgetOTH`;
    return this.http.post<OthersBudget>(API_URL, othObject).pipe(catchError(this.error));
  }

  checkBudgetProject(wbsElement: string) {
    const othObject: WBSBudgetRequest = {
      "Method": "CHECK_BUDG_WBS",
      "WBS_ELEMENT": wbsElement
    }
    let API_URL = `${this.apiURL}/sapapi/checkBudgetProject`;
    return this.http.post<WBSBudget>(API_URL, othObject).pipe(catchError(this.error));

  }
  checkBudgetCapitalAUC(wbsElement: string) {
    const othObject: WBSBudgetRequest = {
      "Method": "CHECK_BUDG_WBS",
      "WBS_ELEMENT": wbsElement
    }
    let API_URL = `${this.apiURL}/sapapi/checkBudgetCapitalAUC`;
    return this.http.post<WBSBudget>(API_URL, othObject).pipe(catchError(this.error));
  }

  getDocumentReference(MPDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/getMyPurchaseDocumentRef/${MPDocumentNumber}`;
    const result = this.http
      .get<DocumentReference[]>(API_URL)
      .pipe(catchError(this.error));
    return result;
  }

  getReasonsForNotUsingRFQ() {
    let API_URL = `${this.apiURL}/api/getReasonsForNotUsingRFQ`;
    return this.http
      .get<ReasonForNotUsingRFQ[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getPurchaseExecutives() {
    let API_URL = `${this.apiURL}/api/getPurchaseExecutivesList`;
    return this.http
      .get<PurchaseExecutiveListResponse>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getPurchaseExecutivesReport(filters: PurchaseExecutivesReportRequest['filters']) {
    let API_URL = `${this.apiURL}/api/reports/purchaseExecutives`;
    return this.http
      .post<PurchaseExecutivesReportResponse>(`${API_URL}`, { filters })
      .pipe(catchError(this.error));
  }


  getDocumentLock(mpDocumentNumber: string, username: string) {
    let API_URL = `${this.apiURL}/api/lockDocument/${mpDocumentNumber}/${username}`;
    return this.http
      .get<DocumentLock>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  downloadMPDocumentFile(MPDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/printDocument/${MPDocumentNumber}`;
    return this.http
      .get<{ data: number[] }>(API_URL)
      .pipe(catchError(this.error));
  }

  getItemTemplateExcelFile(mpDocNumber?: string) {
    let API_URL = `${this.apiURL}/api/downloadTemplate`;
    return this.http
      .get<any>(API_URL)
      // .get<VendorDetails[]>(API_URL + `/${mpDocNumber}`)
      .pipe(catchError(this.error));
  }
  validateItemAttachment(attachment: string, IsContract: boolean) {
    let token = '';
    // await this.auth.getUserSessionId().then((data) => token = data)
    console.log(token);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const httpOptions = {
      headers: httpHeaders,
    };
    let API_URL = `${this.apiURL}/api/validateTemplate`;
    return this.http.post(API_URL, { data: attachment, IsContract: IsContract }).pipe(catchError(this.HanldeUploadError));
  }

  HanldeUploadError(error: HttpErrorResponse) {
    return throwError(() => {
      return error.error;
    });
  }


  downloadFiles(filePaths: string[]) {
    let API_URL = `${this.apiURL}/api/downloadFiles`;
    return this.http
      .post<{ files: { data: string }[] }>(API_URL, { filePaths: filePaths })
      .pipe(catchError(this.error));
  }

  getMyPurchaseDocuments(MPDocumentNumber: string, filters?: { [key: string]: string | boolean }, sortOrder?: [string, "ASC" | "DESC"][]) {
    let API_URL = `${this.apiURL}/api/getMyPurchaseDocuments`;
    return this.http
      .post<RfqItem[]>(`${API_URL}`, { MPDocumentNumber: MPDocumentNumber, filters: filters, sortOrder: sortOrder })
      .pipe(catchError(this.error));
  }

  getPurchaseExecutivesList(username?: string) {
    let API_URL = `${this.apiURL}/api/getPurchaseExecutivesList${username ? `/` + username : ''}`;
    return this.http.get<PurchaseExecutives[]>(`${API_URL}`);
  }

  getTodoPeWorklist(
    limit: string,
    pageNumber: string,
    column: string | null = null,
    isAsc: string | null = null,
  ) {
    let token = '';
    console.log(token);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const httpOptions = {
      headers: httpHeaders,
    };
    let API_URL = `${this.apiURL}/api/getTodoPeWorklist`;
    if (column) {
      return this.http
        .get<MyPEWorkListData>(
          `${API_URL}` + `/${limit}/${pageNumber}?column=${column}&isAsc=${isAsc}`,
          httpOptions
        )
        .pipe(catchError(this.error));
    }
    else {
      return this.http
        .get<MyPEWorkListData>(
          `${API_URL}` + `/${limit}/${pageNumber}`, httpOptions
        )
        .pipe(catchError(this.error));
    }
  }

  markAsDone(payload: MarkasDone) {
    let API_URL = `${this.apiURL}/api/markAsDone`;
    return this.http
      .post<MarkasDone>(`${API_URL}`, payload)
      .pipe(catchError(this.error));
  }

  getDonePeWorklist(
    limit: string,
    pageNumber: string,
    column: string | null = null,
    isAsc: string | null = null,
  ) {
    let token = '';
    console.log(token);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const httpOptions = {
      headers: httpHeaders,
    };
    let API_URL = `${this.apiURL}/api/getDonePeWorklist`;
    if (column) {
      return this.http
        .get<MyPEWorkListData>(
          `${API_URL}` + `/${limit}/${pageNumber}?column=${column}&isAsc=${isAsc}`,
          httpOptions
        )
        .pipe(catchError(this.error));
    }
    else {
      return this.http
        .get<MyPEWorkListData>(
          `${API_URL}` + `/${limit}/${pageNumber}`, httpOptions
        )
        .pipe(catchError(this.error));
    }
  }


  getEstimatedUsages() {
    let API_URL = `${this.apiURL}/api/getEstimatedUsages`;
    return this.http
      .get<EstimatedUsages[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getRFQSummaryData(MPDocumentNumber: string, RFQNumber: string) {
    let API_URL = `${this.apiURL}/api/getRFQSummary/${MPDocumentNumber}/${RFQNumber}`;
    return this.http
      .get<SourcingOutcomeInformation>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getRFQItems(MPDocumentNumber: string, RFQNumber: string) {
    let API_URL = `${this.apiURL}/api/getRFQItems/${MPDocumentNumber}/${RFQNumber}`;
    return this.http
      .get<SourcedItem[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }


  getReasonForNoQuotation() {
    let API_URL = `${this.apiURL}/api/getReasonForNoBid`;
    return this.http
      .get<ReasonForNoQuotaionItem[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getRFQNumbers(MPDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/getRFQNumber/${MPDocumentNumber}`;
    return this.http
      .get<rfqListDropDown[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getRFQAttachment() {
    let API_URL = `${this.apiURL}/api/getRFQAttachment`
    return this.http
      .get<SummaryDropdown[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  downloadAllVendorDoc(MPDocumentNumber: string, RFQNumber: string) {
    let API_URL = `${this.apiURL}/api/downloadAll/${MPDocumentNumber}/${RFQNumber}`
    return this.http
      .get<DropDownOptions[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  downloadVendorFile(MPDocumentNumber: string, RFQNumber: string, VendorNumber: string, QuotaionId?: string | null) {
    let API_URL = `${this.apiURL}/api/downloadQuotation/${MPDocumentNumber}/${RFQNumber}/${VendorNumber}${QuotaionId ? `/` + QuotaionId : ''}`
    return this.http
      .get<DropDownOptions[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  saveRFQSummary(payload: SourcingOutcomeInformation) {
    let API_URL = `${this.apiURL}/api/saveRFQSummary`;
    return this.http.post(`${API_URL}`, payload).pipe(catchError(this.error));
  }

  submitRFQSummary(payload: SourcingOutcomeInformation) {
    let API_URL = `${this.apiURL}/api/submitRFQSummary`;
    return this.http.post(`${API_URL}`, payload).pipe(catchError(this.error));
  }

  // recallRFQSummary(payload: { RFQSummaryNumber: string }) {
  //   let API_URL = `${this.apiURL}/api/recallRFQSummary`;
  //   return this.http.put(API_URL, payload).pipe(catchError(this.error));
  // }

  getRFQSummaryDraft(rfsNumber: string) {
    let API_URL = `${this.apiURL}/api/getDraftRFQSummary`;
    return this.http
      .get<SourcingOutcomeInformation>(`${API_URL}/${rfsNumber}`)
      .pipe(catchError(this.redirectIfUnauthorized.bind(this)), catchError(this.error));
  }

  getAbortReasons() {
    let API_URL = `${this.apiURL}/api/getAbortReasons`;
    return this.http
      .get<SummaryDropdown[]>(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  raiseRFQSummaryPO(payload: any) {
    let API_URL = `${this.apiURL}/api/raiseRFQSummaryPO`;
    return this.http.post(`${API_URL}`, payload, { observe: 'response' }).pipe(catchError(this.error));
  }

  abortRFQSummary(payload: any) {
    let API_URL = `${this.apiURL}/api/abortRFQSummary`;
    return this.http.post(`${API_URL}`, payload, { observe: 'response' }).pipe(catchError(this.error));
  }

  reassignRO(payload: any): Observable<HttpResponse<any>> {
    let API_URL = `${this.apiURL}/api/reassignRO`;
    return this.http.post(`${API_URL}`, payload, { observe: 'response' }).pipe(catchError(this.error));
  }

  reassignPE(payload: any) {
    let API_URL = `${this.apiURL}/api/reassignPE`;
    return this.http.post(`${API_URL}`, payload, { observe: 'response' }).pipe(catchError(this.error));
  }

  recallRfqSummary(payload: any) {
    let API_URL = `${this.apiURL}/api/recallRFQSummaryDocument`;
    return this.http.post(`${API_URL}`, payload, { observe: 'response' }).pipe(catchError(this.error));
  }

  getPurchaseGroupIdInformation(rfqSummaryDocNo: string) {
    let API_URL = `${this.apiURL}/api/getPurchaseGroupIdInformation`;
    return this.http
      .get<PurchaseGroup[]>(`${API_URL}/${rfqSummaryDocNo}`)
      .pipe(catchError(this.redirectIfUnauthorized.bind(this)), catchError(this.error));
  }

  getMPRFQSummary(MPPurchaseOrderGroupId: number) {
    let API_URL = `${this.apiURL}/api/getMPRFQSummary`;
    return this.http
      .get<MPMMSInformation[]>(`${API_URL}/${MPPurchaseOrderGroupId}`)
      .pipe(catchError(this.redirectIfUnauthorized.bind(this)), catchError(this.error));
  }

  completeRfqSummary(payload: any) {
    let API_URL = `${this.apiURL}/api/completedRFQSummary`;
    return this.http.post(`${API_URL}`, payload, { observe: 'response' }).pipe(catchError(this.error));
  }
  getrfqReference(MPDocumentNumber: string) {
    let API_URL = `${this.apiURL}/api/rfqReference/${MPDocumentNumber}`;
    const result = this.http
      .get<RFQReferenceRecord[]>(API_URL)
      .pipe(catchError(this.error));
    return result;
  }
  downloadReferenceRFQ(MPDocumentNumber: string, RFQNumber: string) {
    let API_URL = `${this.apiURL}/api/rfqDownload/${MPDocumentNumber}/${RFQNumber}`
    return this.http
      .get(`${API_URL}`)
      .pipe(catchError(this.error));
  }

  getRFQSummaryReport(filters: RFQReportRequest['filters']) {
    let API_URL = `${this.apiURL}/api/rfqSummaryReport`;
    return this.http
      .post<RFQSummaryReportResponse>(`${API_URL}`, { filters })
      .pipe(catchError(this.error));
  }

  getRFQSummaryListFilter(payload: any) {
    let API_URL = `${this.apiURL}/api/rfqSummaryList`;
    return this.http
      .post<RFQDetailsFilter[]>(`${API_URL}`, payload)
}

getMaintenanceMessage(date: string) {
  let API_URL = `${this.apiURL}/api/getMaintenanceMessage`;
  return this.http
    .get<EstimatedUsages[]>(`${API_URL}` + `?date=${date}`)
    .pipe(catchError(this.error));
}
}